import { useApi } from '@/api';
import { Link, TableSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  Box,
  CryptoIcon,
  CurrencyValue,
  DataTable,
  Flex,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function CallersTable({ pagination, sorting, search }) {
  const [data, error] = useApi({
    url: `/upgrade/usds/callers/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting,
      search: search
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet',
        getCell: (row) => (
          <WalletAddress
            address={row.wallet_address}
            options={{
              name: row.wallet_name
            }}
          />
        ),
        columnSize: ['minmax(100px, auto)', 'minmax(150px, auto)']
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Upgraded
            <CryptoIcon
              name="USDS"
              address={tokensMapping('USDS').address}
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.balance}
            options={{
              iconSize: '0'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'balance'
      },

      {
        header: 'Latest Activity',
        getCell: (row) => (
          <Box color="muted">
            <RelativeDateTime value={row.datetime} />
          </Box>
        ),
        sortingField: 'datetime',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.wallet_address}
        rowLinkProps={{
          to: (row) => row.wallet_address,
          // @ts-ignore
          linkComponent: Link
        }}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
